import { render, staticRenderFns } from "./visitedDetail.vue?vue&type=template&id=6348b743&"
import script from "./visitedDetail.vue?vue&type=script&lang=js&"
export * from "./visitedDetail.vue?vue&type=script&lang=js&"
import style0 from "./visitedDetail.vue?vue&type=style&index=0&id=6348b743&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports